import axios from '../components/shared/axios';

const baseURL = process.env.REACT_APP_STATIC_SERVER_URL;
const staticServerAuthKey = process.env.REACT_APP_STATIC_SERVER_AUTH_KEY;

export const getClasses = async (pageNo, pageSize, param) => {
  let params = {};
  if (param) params = { pageNo, pageSize, ...param };
  else params = { pageNo, pageSize };
  const headers = {
    'auth-token': staticServerAuthKey,
  };
  return await axios.get(`${baseURL}/community-class`, { headers }, { params });
};

export const getClass = async (params) => {
  return await axios.get(`${baseURL}/get-community-class?classCode=${params}`);
};

export const addClass = async (params) => {
  return await axios.post(`${baseURL}/community-class`, params);
};

export const updateClass = async (params, classCode) => {
  return await axios.put(`${baseURL}/community-class/${classCode}`, params);
};

export const deleteClass = async (classCode) => {
  return await axios.delete(`${baseURL}/community-class/${classCode}`);
};

export const getTrialClassRegistration = async (pageNo, pageSize, param) => {
  let params = {};
  if (param) params = { pageNo, pageSize, ...param };
  else params = { pageNo, pageSize };
  const headers = {
    'auth-token': staticServerAuthKey,
  };
  return await axios.get(
    `${baseURL}/community-class-signup`,
    { headers },
    { params }
  );
};
